/* eslint-disable no-console */
import onDOMReady from '../js/utils/onDomReady';

onDOMReady(() => {
    if (document.querySelector('.c-risk-chart') ||
        document.querySelector('.c-unit-price') ||
        document.querySelector('.c-asset-allocation') ||
        document.querySelector('.c-investment-returns') ||
        document.querySelector('.c-annual-returns') ||
        document.querySelector('.c-investment-performance-summary') ||
        document.querySelector('.c-unit-price-summary-table-old') ||
        document.querySelector('.c-unit-price-summary-table') ||
        document.querySelector('.c-unit-price-old') ||
        document.querySelector('.c-unit-price-table') ||
        document.querySelector('.c-superannuation-product-dashboard') ||
        document.querySelector('.c-portfolio-holdings-table') ||
        document.querySelector('.c-market-commentary')) {
        import('./charts').then(() => {
            console.info('Loaded JS: ./charts');
        });
    }
});
